import { site } from '../data/site'
import { productBenefits } from '../data/productBenefits'
import { categoryTitle } from './products'
import type { Product } from '../types/product'

export function truncate(text: string, max = 158): string {
  if (text.length <= max) return text
  const cut = text.slice(0, max - 1)
  return `${cut.slice(0, cut.lastIndexOf(' '))}…`
}

export function productMetaDescription(p: Product): string {
  const first = productBenefits[p.slug]?.[0]
  return truncate(`${p.name} van AMIRA Beauty: ${p.benefit} ${first ? first.text : ''} Morgen in huis.`)
}

export function breadcrumbJsonLd(items: { name: string; path: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.name,
      item: `${site.url}${it.path}`,
    })),
  }
}

export function organizationJsonLd() {
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: site.name,
      url: site.url,
      slogan: 'Beauty, made personal.',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: site.name,
      url: site.url,
      inLanguage: 'nl-NL',
    },
  ]
}

export function productJsonLd(p: Product) {
  const url = `${site.url}/product/${p.slug}`
  const prices = p.variants.map((v) => v.price)
  const availability = 'https://schema.org/InStock'
  const offers =
    p.variants.length > 1
      ? {
          '@type': 'AggregateOffer',
          priceCurrency: 'EUR',
          lowPrice: Math.min(...prices).toFixed(2),
          highPrice: Math.max(...prices).toFixed(2),
          offerCount: p.variants.length,
          availability,
          url,
        }
      : {
          '@type': 'Offer',
          priceCurrency: 'EUR',
          price: prices[0].toFixed(2),
          availability,
          itemCondition: 'https://schema.org/NewCondition',
          url,
        }

  return [
    {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: p.name,
      description: `${p.what} ${p.does}`,
      image: p.gallery,
      sku: p.slug,
      category: categoryTitle(p.category),
      brand: { '@type': 'Brand', name: site.name },
      aggregateRating: { '@type': 'AggregateRating', ratingValue: p.rating, reviewCount: p.reviews },
      offers,
    },
    breadcrumbJsonLd([
      { name: 'Home', path: '/' },
      { name: categoryTitle(p.category), path: `/collectie/${p.category}` },
      { name: p.name, path: `/product/${p.slug}` },
    ]),
  ]
}
